import React from 'react';

export function BasisgegevensValue(props: { value: undefined | string | number; unit?: string }) {
    if (props.value) {
        return (
            <>
                {props.value}
                {props.unit ? ` ${props.unit}` : ''}
            </>
        );
    }
    return (
        <>
            <i>Waarde onbekend</i>
        </>
    );
}
